var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAzureStyleBlack = function SvgBrandAzureStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#svg_icon_BrandAzureStyleBlack__clip0_3286_1493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02.753h7.093L7.749 22.572a1.13 1.13 0 0 1-1.072.77h-5.52a1.13 1.13 0 0 1-1.07-1.491l6.86-20.328A1.13 1.13 0 0 1 8.02.753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.327 15.388H7.078a.521.521 0 0 0-.355.901l7.228 6.746c.21.197.488.306.776.306h6.369z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02.753a1.12 1.12 0 0 0-1.075.784L.095 21.832a1.128 1.128 0 0 0 1.065 1.51h5.663a1.21 1.21 0 0 0 .93-.791l1.365-4.026 4.88 4.551c.204.17.46.263.726.265h6.345l-2.783-7.953-8.113.001L15.139.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.08 1.521a1.13 1.13 0 0 0-1.07-.768H8.104a1.13 1.13 0 0 1 1.07.768l6.861 20.33a1.13 1.13 0 0 1-1.07 1.49h7.906a1.13 1.13 0 0 0 1.07-1.49z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAzureStyleBlack__clip0_3286_1493"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAzureStyleBlack);
export { ForwardRef as ReactComponent };